'use client'
import React from 'react'
import { Autoplay, Navigation, Pagination } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'

function WordsOfAppreciation() {
   return (
      <>
         <div className="container">
            <h2 className="section_heading_title tech_title">
               Words Of Appreciation
            </h2>
            <p className="section_desc features_description mb-2 pb-3">
               Explore how our solutions have transformed businesses and
               enriched lives. See firsthand why our customers trust us
               repeatedly to deliver results that make a real difference.
            </p>
            <div className="slider-column">
               <Swiper
                  modules={[Navigation, Pagination, Autoplay]}
                  loop={true}
                  centeredSlides={true}
                  autoplay={{
                     delay: 3000,
                     disableOnInteraction: false,
                  }}
                  speed={1000}
                  grabCursor={true}
                  freeMode={false}
                  mousewheel={false}
                  keyboard={{ enabled: true }}
                  effect={'coverflow'}
                  slidesPerView={1}
                  pagination={{
                     el: '.swiper-pagination-slider-2',
                     dynamicBullets: false,
                     clickable: true,
                     renderBullet: (index, className) =>
                        `<span class='${className} custom-bullet'></span>`,
                  }}
                  navigation={{
                     nextEl: '.custom-next-btn2',
                     prevEl: '.custom-prev-btn2',
                  }}
                  breakpoints={{
                     320: { slidesPerView: 1, spaceBetween: 100 },
                     640: { slidesPerView: 1, spaceBetween: 200 },
                     768: { slidesPerView: 1, spaceBetween: 200 },
                     1100: { slidesPerView: 1, spaceBetween: 500 },
                  }}
                  coverflowEffect={{
                     rotate: 0,
                     stretch: -10,
                     depth: 200,
                     modifier: 2,
                     slideShadows: true,
                  }}
                  className="custom-slider-2"
               >
                  <SwiperSlide className="custom-slider-component-card2">
                     <div className="appreciation-parent">
                        <div className="appreciate_img_parent">
                           <img
                              src="/assets/svg/clientfeedback/care.webp"
                              alt="care"
                           />
                        </div>
                        <div className="appreciation_card">
                           <div className="apppreciation_description">
                              Care Boarding has been a game-changer for our home
                              healthcare agency. The platform has significantly
                              improved our ability to recruit, schedule, and
                              manage our caregivers. We've seen a noticeable
                              increase in patient satisfaction and have been
                              able to reduce operational costs. The EVV
                              compliance features have been invaluable in
                              ensuring regulatory adherence. We are extremely
                              satisfied with our partnership with Care Boarding.
                           </div>
                           <div className="single_dash mt-4 mb-2"></div>
                           <div className="d-flex justify-content-between align-items-center">
                              <div className="footer_card_first d-flex justify-content-center align-items-center">
                                 <span className="footer_cnt_1">
                                    Udaya Acharya
                                 </span>
                                 <div className="vertical_dash"></div>
                                 <span className="footer_cnt_2">USA</span>
                              </div>

                              <div className="footer_card_second d-flex justify-content-center align-items-end">
                                 <span className="footer_cnt_3">Owner</span>
                                 <div className="vertical_dash"></div>
                                 <span className="footer_cnt_4">
                                    Golden Home Healthcare
                                 </span>
                              </div>
                           </div>
                        </div>
                     </div>
                  </SwiperSlide>
                  {/* <SwiperSlide className='custom-slider-component-card2'>
                     <div className="appreciation-parent">
                        <div className="appreciate_img_parent">
                           <img src="/assets/svg/clientfeedback/cam.webp" alt='cam' />
                        </div>
                        <div className="appreciation_card">
                           <div className="apppreciation_description">
                              The team at Benzatine has truly transformed my
                              trading experience with Robot Maker. I never
                              thought creating my own trading robots could be so
                              straightforward, but the intuitive drag-and-drop
                              interface made it easy. The variety of features
                              and expert assistance provided by the Benzatine
                              team have been instrumental in my journey. Thanks
                              to their innovation, I now have full control over
                              my trading and am excited to explore new
                              possibilities.
                           </div>
                           <div className="single_dash mt-4 mb-2"></div>
                           <div className="d-flex justify-content-between align-items-center">
                              <div className="footer_card_first d-flex justify-content-center align-items-center">
                                 <span className="footer_cnt_1">
                                    Cameron Madlani
                                 </span>
                                 <div className="vertical_dash"></div>
                                 <span className="footer_cnt_2">USA</span>
                              </div>

                              <div className="footer_card_second d-flex justify-content-center align-items-end">
                                 <span className="footer_cnt_3">
                                    CTO & Founder
                                 </span>
                                 <div className="vertical_dash"></div>
                                 <span className="footer_cnt_4">
                                    Robotmaker.AI
                                 </span>
                              </div>
                           </div>
                        </div>
                     </div>
                  </SwiperSlide> */}
                  <SwiperSlide className="custom-slider-component-card2">
                     <div className="appreciation-parent">
                        <div className="appreciate_img_parent">
                           <img
                              src="/assets/svg/clientfeedback/yong.webp"
                              alt="yong"
                           />
                        </div>
                        <div className="appreciation_card">
                           <div className="apppreciation_description">
                              He is an exceptional leader and developer whose
                              extensive knowledge in software development has
                              been instrumental in our team's success. Brijesh
                              possesses a unique blend of technical expertise
                              and problem-solving skills, which he applies
                              effectively to understand and meet client needs,
                              even in the most challenging situations.
                              <br />
                              His contributions have not only led to successful
                              project outcomes but also to high client
                              satisfaction. I confidently look forward to future
                              collaborations with him and recommend him highly
                              for his remarkable skills and leadership.
                           </div>
                           <div className="single_dash mt-4 mb-2"></div>
                           <div className="d-flex justify-content-between align-items-center">
                              <div className="footer_card_first d-flex justify-content-center align-items-center">
                                 <span className="footer_cnt_1">Kim Young</span>
                                 <div className="vertical_dash"></div>
                                 <span className="footer_cnt_2">
                                    South Korea
                                 </span>
                              </div>

                              <div className="footer_card_second d-flex justify-content-center align-items-end">
                                 <span className="footer_cnt_3">CEO</span>
                                 <div className="vertical_dash"></div>
                                 <span className="footer_cnt_4">Hiblocks</span>
                              </div>
                           </div>
                        </div>
                     </div>
                  </SwiperSlide>
                  <div className="d-flex justify-content-center slider-1-navigation-parent">
                     <button className="custom-prev-btn2">
                        <img src="/assets/svg/left_arrow.svg" alt="prev" />
                     </button>
                     <div className="d-flex align-items-center justify-content-center">
                        <span className="d-flex align-items-center justify-content-center swiper-pagination-slider-2"></span>
                     </div>
                     <button className="custom-next-btn2">
                        <img src="/assets/svg/right_arrow.svg" alt="prev" />
                     </button>
                  </div>
               </Swiper>
            </div>
         </div>
      </>
   )
}

export default WordsOfAppreciation
